module.exports = __webpack_public_path__ + "img/step_5.80b95e57.png";